export enum ScheduleCycleType{
    ByWeekDay = 1,
    DayOfMonth = 2,
    DayOfTheMonth = 3
}



// WEBPACK FOOTER //
// ./src/app/supply-schedules/models/schedule-cycle-type.ts